import styled from 'styled-components';

import { HighlightedSm } from 'modules/ui/typography';

export const Label = styled(HighlightedSm)<{ textAlign?: string }>`
  text-align: ${({ textAlign }): string => textAlign || 'center'};
`;
